/**
 * Re-exporta desde el módulo RBAC para compatibilidad.
 * En nuevo código usar: import { getCurrentRole, canAccess } from '../rbac'
 */
export { getPermissionRole } from '../rbac';



// WEBPACK FOOTER //
// ./src/util/getPermissionRole.js